import React from 'react';
import Icon, { IconProps } from '../Icon';

const DuplicateIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 11 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.975 7.10051V1.69951C7.97354 1.46708 7.88019 1.24466 7.71531 1.08081C7.55044 0.916966 7.32744 0.825008 7.095 0.825012H1.6995C1.46706 0.826465 1.24464 0.91982 1.0808 1.08469C0.916951 1.24957 0.824992 1.47257 0.824997 1.70501V7.10601C0.824997 7.3394 0.917711 7.56323 1.08274 7.72827C1.24777 7.8933 1.47161 7.98601 1.705 7.98601H7.106C7.33843 7.98311 7.56028 7.88836 7.72309 7.72246C7.88591 7.55655 7.97647 7.33296 7.975 7.10051ZM1.375 7.10051V1.69951C1.37641 1.61389 1.41106 1.53217 1.47161 1.47162C1.53216 1.41107 1.61388 1.37643 1.6995 1.37501H7.1005C7.18707 1.375 7.27019 1.40901 7.33192 1.46971C7.39365 1.53042 7.42905 1.61295 7.4305 1.69951V7.10051C7.4305 7.18803 7.39573 7.27197 7.33384 7.33386C7.27195 7.39574 7.18802 7.43051 7.1005 7.43051H1.6995C1.61293 7.42907 1.5304 7.39367 1.4697 7.33193C1.409 7.2702 1.37498 7.18709 1.375 7.10051ZM10.175 3.89951V9.30051C10.175 9.5339 10.0823 9.75773 9.91725 9.92277C9.75222 10.0878 9.52839 10.1805 9.295 10.1805H3.8995C3.66611 10.1805 3.44227 10.0878 3.27724 9.92277C3.11221 9.75773 3.0195 9.5339 3.0195 9.30051V8.53051H3.5695V9.30051C3.5695 9.38803 3.60426 9.47197 3.66615 9.53386C3.72804 9.59574 3.81198 9.63051 3.8995 9.63051H9.3005C9.38802 9.63051 9.47195 9.59574 9.53384 9.53386C9.59573 9.47197 9.6305 9.38803 9.6305 9.30051V3.89951C9.6305 3.81199 9.59573 3.72805 9.53384 3.66617C9.47195 3.60428 9.38802 3.56951 9.3005 3.56951H8.5305V3.01951H9.3005C9.53293 3.02097 9.75535 3.11432 9.9192 3.27919C10.083 3.44407 10.175 3.66707 10.175 3.89951Z"
          fill="currentColor"
        />
      </svg>
    </Icon>
  );
};

export default DuplicateIcon;
